import gql from 'graphql-tag'

export const dashboardFinancerEvaluations = gql`
  query DashboardFinancerEvaluations ($model: loans_evaluation_bool_exp) {
  records: loans_evaluation(where: $model) {
    id
    createdAt: created_at
    financing {
      id
      saleOrder: sale_order {
        id
        deal {
          id
          auto {
            id
            registrationPlate: registration_plate
            version: version_year {
              id
              year {
                id
              }
              version {
                id
                name
                model {
                  id
                  name
                  brand {
                    id
                    name
                  }
                }
              }
            }
          }
          lead {
            id
            executive {
              id
              person {
                id
                firstName: first_name
                surname
                type {
                  name
                }
              }
            }
          }
        }
      }
    }
    signedDate: signed_date
    status {
      id
      description
      color
      status {
        id
        name
        description
        color
      }
    }
    closingReason: closing_reason {
      id
      description
      color
      type {
        id
        name
        description
        color
      }
    }
  }
}

`
